import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { Note } from '../components/participants/note/note';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  createNote(note: Note):Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl + 'note/createNote', note, {headers:headers});
  }

  getCourseNotesForUser(id: string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams()
    params = params.append('id', id.toString());
    return this.http.get<Note[]>(this.apiUrl + 'note/getCourseNotesForUser', {params:params, headers:headers, observe:'response'});
  }

  getNote(id: number):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams()
    params = params.append('id', id.toString());
    return this.http.get<Note[]>(this.apiUrl + 'note/getNote', {params:params, headers:headers, observe:'response'});
  }

  deleteNote(id:number):Observable<any>{
    const token = this._authservice.getAuthToken();
    const header = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams()
    params = params.append('id', id.toString());
    return this.http.post<any>(this.apiUrl + 'note/deleteNote', null, {headers:header, params:params});
  }

  updateNote(note: Note):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl + 'note/updateNote', note, {headers:headers});
  }
}
